import * as React from 'react';
import { observer } from 'mobx-react-lite';

import styles from './CalendarDayList.scss';

/**
 * Props for calendar all day well
 */
export interface CalendarAllDayWellProps {
    allDayContent: React.ReactNode;
    allDayRowCount: number;
    children?: React.ReactNode;
}

/**
 * The control is showing calendar all day events
 */
export default observer(
    function CalendarAllDayWell(props: CalendarAllDayWellProps, ref: (e: HTMLElement) => void) {
        const numberOfVisibleAllDayItems = 4;
        let { allDayContent, children, allDayRowCount } = props;

        let style = {
            height: allDayRowCount > numberOfVisibleAllDayItems ? '100%' : 'auto',
        };

        return (
            <div
                ref={ref}
                className={styles.allDayPanel}
                key="alldaypanel_1"
                data-is-scrollable={true}>
                {children}
                <div className={styles.renderAllDayPanel} style={style}>
                    {allDayContent}
                </div>
            </div>
        );
    },
    { forwardRef: true }
);
